import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import "../styles/tuberia_cedulas.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";
import tubored from "../img/tubo_redondo.png";
import tubocerq from "../img/tubo_cerquero_1.png";
import tubced from "../img/tubo_cedula1.png";

const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];

const NavBar = () => {
  const navigate = useNavigate(); // ✅ Hook para navegación

  const [navbarColor, setNavbarColor] = useState("#354a66");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("#354a66");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`} style={{ color: "#fff" }}>
                  {/* ✅ Hacer que "Productos" sea clickeable y navegue */}
                  {item.link && (
                    <NavDropdown.Item onClick={() => navigate(item.link)} style={{ color: "#fff", fontWeight: "bold" }}>
                      {item.name}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {item.dropdown.map((subItem, subIndex) => (
                    <NavDropdown.Item key={subIndex} href={subItem.link} style={{ color: "#fff" }}>
                      {subItem.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff", transition: "color 0.3s ease" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
const TuboRedondo = () => {
  return (
    <section>
      <div className="servicios-container" style={{ textAlign: "center" }}>
        <div
          className="servicios-title"
          style={{
            marginTop: "130px",
            fontSize: "3rem",
            fontWeight: "bold",
            color: "#f58634",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            padding: "10px",
            animation: "fadeIn 1s ease-in-out",
            textAlign: "center",
          }}
        >
          Tubo Redondo Cédulas
        </div>
      </div>
      <div className="row" style={{ marginTop: '50px', display: 'flex', alignItems: 'center' }}>
        {/* Descripción del producto con imágenes alineadas */}
        <div className="col-md-4 d-flex flex-column justify-content-center align-items-center"
          style={{ height: 'auto', textAlign: 'justify' }}>
          <p style={{ marginLeft: '10px', textAlign: 'justify' }}>
          Las tuberías de acero con diferentes cédulas se utilizan en una variedad de aplicaciones
            industriales, y se clasifican según el grosor de sus paredes, lo que determina su resistencia a la
            presión y durabilidad. Dependiendo de la cédula, estas tuberías son aptas para sistemas de agua,
            gas, procesos industriales y más, proporcionando una solución confiable y resistente. Disponibles en
            varias cédulas (30, 40, y 80), ofrecen versatilidad en proyectos que requieren una alta resistencia
            o en condiciones más estándar.          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px', zIndex: '10' }}>
            <img src={tubored} alt="Tubo Redondo" className="img-fluid custom-img" />
            <img src={tubced} alt="Tubo Cédula" className="img-fluid custom-img" />
            <img src={tubocerq} alt="Tubo Cerquero" className="img-fluid custom-img" />
          </div>
        </div>

        {/* Tabla del producto */}
        <div className="col-md-8">
          {/* Contenedor con scroll para las tablas */}
          <div style={{ maxHeight: '70vh', overflowY: 'auto', maxWidth: '100%', margin: '0 auto' }}>
            <table className="table table-striped" >
              <thead>
                <tr>
                  <th colspan="8" className="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px;", background: '#f58634' }}>
                    Tubería Redonda Cédula 30
                  </th>
                </tr>
                <tr>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Día. Nom. (pulg)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Dia. Ext. (pulg)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Calibre (nom)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor (pulg)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Inventario</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Longitud (metros)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Piezas x Paquete</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Kilogramo x Metro</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff;" }}>
                  <td>1/2"</td>
                  <td>0.840"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>169.00</td>
                  <td>0.91</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3/4"</td>
                  <td>1.050"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>127.00</td>
                  <td>1.16</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1"</td>
                  <td>1.315"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>91.00</td>
                  <td>1.47</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/4"</td>
                  <td>1.660"</td>
                  <td>13</td>
                  <td>0.0897</td>
                  <td>N</td>
                  <td>6</td>
                  <td>61.00</td>
                  <td>2.24</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1 1/2"</td>
                  <td>1.900"</td>
                  <td>13</td>
                  <td>0.0897</td>
                  <td>N</td>
                  <td>6</td>
                  <td>61.00</td>
                  <td>2.58</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>2"</td>
                  <td>2 3/8"</td>
                  <td>12</td>
                  <td>0.1046</td>
                  <td>N</td>
                  <td>6</td>
                  <td>37.00</td>
                  <td>3.77</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2 1/2"</td>
                  <td>2 7/8"</td>
                  <td>12</td>
                  <td>0.1046</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>37</td>
                  <td>4.61</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3"</td>
                  <td>3 1/2"</td>
                  <td>11</td>
                  <td>0.1046</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>19.00</td>
                  <td>6.43</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>4"</td>
                  <td>4 1/2"</td>
                  <td>11</td>
                  <td>0.1196</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>19.00</td>
                  <td>8.33</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6"</td>
                  <td>6 5/8"</td>
                  <td>3/16"</td>
                  <td>0.1875</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>7.00</td>
                  <td>19.18</td>
                </tr>
              </tbody>
            </table>

            <table className="table table-striped" style={{ textAlign: 'center' }}>
              <thead>
                <tr>
                  <th colspan="8" className="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px", background: '#f58634' }}>
                    Tubería Redonda Cédula 40
                  </th>
                </tr>
                <tr>
                  <th style={{ background: "#ffe4b2", color: "#000;" }}>Día. Nom. (pulg)</th>
                  <th style={{ background: "#ffe4b2", color: "#000;" }}>Dia. Ext. (pulg)</th>
                  <th style={{ background: "#ffe4b2", color: "#000;" }}>Calibre (nom)</th>
                  <th style={{ background: "#ffe4b2", color: "#000;" }}>Espesor (pulg)</th>
                  <th style={{ background: "#ffe4b2", color: "#000;" }}>Inventario</th>
                  <th style={{ background: "#ffe4b2", color: "#000;" }}>Longitud (metros)</th>
                  <th style={{ background: "#ffe4b2", color: "#000;" }}>Piezas x Paquete</th>
                  <th style={{ background: "#ffe4b2", color: "#000;" }}>Kilogramo x Metro</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff" }}>
                  <td>1/2"</td>
                  <td>0.840"</td>
                  <td>12</td>
                  <td>0.1046</td>
                  <td>N</td>
                  <td>6.40</td>
                  <td>91</td>
                  <td>1.22</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3/4"</td>
                  <td>1.050"</td>
                  <td>12</td>
                  <td>0.1046</td>
                  <td>N</td>
                  <td>6.40</td>
                  <td>91</td>
                  <td>1.57</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1"</td>
                  <td>1.315"</td>
                  <td>10</td>
                  <td>0.1345</td>
                  <td>N</td>
                  <td>6490</td>
                  <td>61</td>
                  <td>2.52</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>1 1/4"</td>
                  <td>1.660"</td>
                  <td>10</td>
                  <td>0.1345</td>
                  <td>N</td>
                  <td>6.40</td>
                  <td>37</td>
                  <td>3.26</td>
                </tr>
                <tr style={{ background: "#fff;" }}>
                  <td>1 1/2"</td>
                  <td>1.900"</td>
                  <td>10</td>
                  <td>0.1345</td>
                  <td>N</td>
                  <td>6.40</td>
                  <td>37</td>
                  <td>4.16</td>
                </tr>
                <tr style={{ background: "#ffe4b2;" }}>
                  <td>2"</td>
                  <td>2 3/8"</td>
                  <td>9</td>
                  <td>0.1495</td>
                  <td>N</td>
                  <td>6.00</td>
                  <td>37</td>
                  <td>5.29</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>2 1/2"</td>
                  <td>2 7/8"</td>
                  <td>0.203"</td>
                  <td>0.2030</td>
                  <td>N</td>
                  <td>6.00/6.40</td>
                  <td>37</td>
                  <td>11.67</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3"</td>
                  <td>3 1/2"</td>
                  <td>4</td>
                  <td>0.2242</td>
                  <td>N</td>
                  <td>6.00/6.40</td>
                  <td>19</td>
                  <td>11.67</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>4"</td>
                  <td>4 1/2"</td>
                  <td>4</td>
                  <td>0.2242</td>
                  <td>PR/N</td>
                  <td>6.00/6.40</td>
                  <td>19</td>
                  <td>15.24</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>6"</td>
                  <td>6 5/8"</td>
                  <td>0.280"</td>
                  <td>0.2800</td>
                  <td>PR/N</td>
                  <td>6.00/6.40</td>
                  <td>7</td>
                  <td>28.24</td>
                </tr>

              </tbody>
            </table>
            <table class="table table-striped" >
              <thead>
                <tr>
                  <th colspan="8" className="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px", background: '#f58634' }}>
                    Tubería Redonda Cédula 80
                  </th>
                </tr>
                <tr>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Día. Nom. (pulg)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Dia. Ext. (pulg)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Inventario</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Longitud (metros)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Piezas x Paquete</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Kilogramo x Metro</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff" }}>
                  <td>0.216"</td>
                  <td>0.2160</td>
                  <td>N</td>
                  <td>6.40</td>
                  <td>37</td>
                  <td>7.41</td>
                </tr>
              </tbody>
            </table>

            <ul>
              <p>Productos especiales sujetos a mínimos de fabricación. </p>
              <li>N-Natural.</li>
              <li>PR-Pintado Rojo.</li>
            </ul>
          </div>
        </div>
      </div>
    </section >
  );
}

const Servicios = () => {
  return (
    <section className="nservicios text-center my-5">
      <h3>Nuestros Servicios</h3>
      <div className="servicios-container">
        <Link to='/servicio#corte_laser' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Corte Láser</p>
            <img src={require("../img/laser.png")} alt="Corte Láser" />
          </div>
        </Link>
        <Link to='/servicio#corte_tubo' style={{ textDecoration: 'none' }} >
          <div className="servicio">
            <p>Corte de Tubo</p>
            <img src={require("../img/corte_recto.png")} alt="Corte Recto" />
          </div>
        </Link>
        <Link to='/servicio#doblez' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Doblez de Lámina</p>
            <img src={require("../img/dobladora-lamina.png")} alt="Doblez de Lámina" />
          </div>
        </Link>
        <Link to='/servicio#doblez-tubo' style={{textDecoration:'none'}}>
          <div className="servicio">
            <p style={{ fontSize: "13px" }}>Doblez de Tubo</p>
              <img src={require("../img/dobladora-tubo.JPG")} alt="Doblez de Tubo" />
          </div>
        </Link>

      </div>
    </section>
  );
};

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const Tuberia_cedulas = () => {
  return (
    <div>
      <NavBar />
      <TuboRedondo />
      <Servicios />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Tuberia_cedulas;
